module.exports = __webpack_public_path__ + "img/equipment.da476249.svg";